module.exports = __webpack_public_path__ + "static/media/YM59_8.f6071903.jpg";